import { render, staticRenderFns } from "./CategoryItemsTab.vue?vue&type=template&id=20dd8ea9&scoped=true"
import script from "./CategoryItemsTab.vue?vue&type=script&lang=js"
export * from "./CategoryItemsTab.vue?vue&type=script&lang=js"
import style0 from "./CategoryItemsTab.vue?vue&type=style&index=0&id=20dd8ea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd8ea9",
  null
  
)

export default component.exports